import React, { useMemo } from "react";
import Avatar from "../../../../../components/Avatar";
import { Grid, Tooltip } from "@mui/material";
import moment from "moment";
import { createAvtarName, hasImage } from "../../../../../utils";
import { useResponsive } from "../../../../../hooks/useResponsive";

function FeedGitHistory({ history }) {
  const isMobile = useResponsive("down", "md");

  const userData = useMemo(() => ({
    username: history?.response_object?.user_object?.username || '',
    userImage: history?.response_object?.user_object?.user_image,
  }), [history?.response_object?.user_object]);

  const formattedDate = useMemo(() => (
    moment.utc(history?.at_time)
      .local()
      .format(isMobile ? "MMM D, YYYY [at] h:mm A" : "MMMM D, YYYY [at] h:mm A")
  ), [history?.at_time, isMobile]);

  if (!history) return null;

  return (
  
        <Grid
          container
          spacing={2}
          sx={{
            width: isMobile
              ? "calc(100% - 10px) !important"
              : "calc(100% + 16px) !important",
          }}
          className="worklog-item d-flex justify-content-space-between">
          <Grid item xs={isMobile ? 12 : 9}>
            <div className="d-flex w-100">
              <Avatar
                // key={`user-avtar-${el.user_id}`}
                username={userData.username}
                user_image={userData.userImage}
                title={userData.username}
                className="user-avtar-dropdown user-avatar mr-8">
                {createAvtarName(userData.username)}
              </Avatar>
              <div className="w-100">
                <div
                  className={
                    isMobile
                      ? "d-flex justify-content-space-between mt-2"
                      : "d-flex justify-content-space-between"
                  }>
                  <div
                    className={
                      isMobile
                        ? "d-flex align-items-center flex-dir-col"
                        : "d-flex align-items-center"
                    }>
                    <div>
                      <Tooltip title={"ABC"}>
                        <a
                          className="board-anquor cursor-pointer"
                        >
                        </a>
                      </Tooltip>
                      <p className="worklog-title mr-2">
                      {userData.username}
                      </p>
                    </div>
                  </div>
                </div>
                <p
                  className={
                    isMobile
                      ? "worklog-worklog comment-content mt-4"
                      : "worklog-worklog comment-content"
                  }
                  dangerouslySetInnerHTML={{
                    __html: history?.history_text,
                  }}></p>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={isMobile ? 12 : 3}
            sx={{ paddingTop: isMobile && "0px !important" }}>
            <div className={"right-details d-flex"}>
              <p className="worklog-date-time comment-date comment">
                Updated on{" "}
              </p>
              <p className="worklog-date-time comment-date">
                {/* {!sameDay && <img src={lateIcon} className="late-icon" />} */}
                {formattedDate}
              </p>
            </div>
          </Grid>
        </Grid>
      )
}

export default React.memo(FeedGitHistory);
